// extracted by mini-css-extract-plugin
module.exports = {"new-nav-toggler":"NewNavToggler_new-nav-toggler__2-A0t","legacy-padding":"NewNavToggler_legacy-padding__3YQrD"};